export const SELECTION_UPPER_LIMIT = 10

// Fixed width reserved for the y-axis gutter, applied in the chart config via scales.y.afterFit
// Pinning it makes the plot area's left edge a constant, which is what the logo row's margin-left keys off of
// Sized for this component's widest tick label ($5,800B)
// Kept in sync manually with --chart-y-axis-gutter in stylesheets/dashboards/dashboards.css
// These two match exactly, because the logo row here has to align 1:1 with the bars
export const Y_AXIS_GUTTER_PX = 55

// Mobile counterpart of the gutter above, smaller because the y-axis tick font drops 11 -> 10 on mobile
// Kept in sync manually with --chart-y-axis-gutter-mobile in stylesheets/dashboards/dashboards.css
export const Y_AXIS_GUTTER_MOBILE_PX = 48

export const COMPS_TILE_SECTIONS_LIST = [
    { id: 'size',      name: 'Size',      ids: [1, 2] },
    { id: 'operating', name: 'Operating', ids: [7, 6, 16, 9, 14, 13, 15, 17, 18] },
    { id: 'valuation', name: 'Valuation', ids: [5, 4, 3, 8, 12, 11, 10] },
]

export const COMPS_DEFAULT_MULT = 'ttmRevenueMultiple'

export const COMPS_MULT_OPTIONS = [
    'ttmRevenueMultiple', 
    'currentYearRevenueMultiple', 
    'nextYearRevenueMultiple', 
    'ttmPeMultiple', 
    'currentYearPeMultiple', 
    'nextYearPeMultiple',
    'ttmEbitdaMultiple' 
]

// Charted tile field -> the underlying/nominal figure on the company object that the charted field was enriched from, which we surface as a companion line in that bar's tooltip
// name: the clean display label for the companion line | field: the key to resolve the value off the company object
// [NOTE]: no unit/suffix here on purpose - that is a presentation concern and is handled where the tooltip line is formatted, not in the identity data
export const PC_TOOLTIP_TILE_COMPANION_DICTIONARY = {
    // ---- 1:1 ---- //
    currentRevenueGrowth:       [{ name: "Current Rev Est.", field: "currentYearRevEst" }],
    forwardRevenueGrowth:       [{ name: "Forward Rev Est.", field: "nextYearRevEst"    }],
    ttmGrossMargin:             [{ name: "LTM Gross Profit", field: "ttmGrossProfit"    }],
    ttmEbitdaMargin:            [{ name: "LTM EBITDA",       field: "ttmEbitda"         }],
    currentEarningsGrowth:      [{ name: "Current EPS Est.", field: "currentYearEpsEst" }],
    forwardEarningsGrowth:      [{ name: "Forward EPS Est.", field: "nextYearEpsEst"    }],
    dividendYield:              [{ name: "Dividend Amount", field: "dividendAmount"     }],

    ttmRevenueMultiple:         [{ name: "LTM Revenue",      field: "ttmRevenue"        }],
    currentYearRevenueMultiple: [{ name: "Current Rev Est.", field: "currentYearRevEst" }],
    nextYearRevenueMultiple:    [{ name: "Forward Rev Est.", field: "nextYearRevEst"    }],
    ttmEbitdaMultiple:          [{ name: "LTM EBITDA",       field: "ttmEbitda"         }],
    ttmPeMultiple:              [{ name: "LTM EPS",          field: "ttmEps"            }],
    currentYearPeMultiple:      [{ name: "Current EPS Est.", field: "currentYearEpsEst" }],
    nextYearPeMultiple:         [{ name: "Forward EPS Est.", field: "nextYearEpsEst"    }],

    // ---- 1:2 ---- //
    ruleOf40:                   [
                                  { name: "Rev. Growth",   field: "forwardRevenueGrowth" },
                                  { name: "EBITDA Margin", field: "ttmEbitdaMargin"      },
                                ],
}

/*
    return {
        id:                         row.id,
        ticker:                     row.ticker,
        name:                       row.name,
        enterpriseValue:            abstractedMetrics.enterpriseValue,
        netDebtToMarketEquity:      abstractedMetrics.netDebtToMarketEquity,
        marketCapitalization:       row.marketCapitalization,
        sharePrice:                 row.sharePrice,
        dividendAmount:             row.dividendAmount,
        dividendYield:              abstractedMetrics.dividendYield,
        shares:                     row.shares,
        totalDebt:                  row.totalDebt,
        totalCash:                  row.totalCash,
        priorYearEbitda:            row.priorYearEbitda,
        ttmEbitda:                  row.ttmEbitda,
        ttmEbitdaMultiple:          abstractedMetrics.ttmEbitdaMultiple,
        ttmEbitdaMargin:            abstractedMetrics.ttmEbitdaMargin,
        ttmGrossProfit:             row.ttmGrossProfit,
        ttmGrossMargin:             abstractedMetrics.ttmGrossMargin,
        priorYearRevenue:           row.priorYearRevenue,
        ttmRevenue:                 row.ttmRevenue,
        currentYearRevEst:          row.currentYearRevEst,
        nextYearRevEst:             row.nextYearRevEst,
        ttmRevenueMultiple:         abstractedMetrics.ttmRevenueMultiple,
        currentYearRevenueMultiple: abstractedMetrics.currentYearRevenueMultiple,
        nextYearRevenueMultiple:    abstractedMetrics.nextYearRevenueMultiple,
        currentRevenueGrowth:       abstractedMetrics.currentRevenueGrowth,
        forwardRevenueGrowth:       abstractedMetrics.forwardRevenueGrowth,        
        ttmNetIncome:               row.ttmNetIncome,
        ttmEps:                     abstractedMetrics.ttmEps,
        priorYearNetIncome:         row.priorYearNetIncome,
        priorYearEps:               abstractedMetrics.priorYearEps,
        currentYearEpsEst:          row.currentYearEpsEst,
        nextYearEpsEst:             row.nextYearEpsEst,
        ttmPeMultiple:              abstractedMetrics.ttmPeMultiple,
        currentYearPeMultiple:      abstractedMetrics.currentYearPeMultiple,
        nextYearPeMultiple:         abstractedMetrics.nextYearPeMultiple,
        currentEarningsGrowth:      abstractedMetrics.currentEarningsGrowth,
        forwardEarningsGrowth:      abstractedMetrics.forwardEarningsGrowth,        
        fiftyTwoWeekHigh:           row.fiftyTwoWeekHigh,
        fiftyTwoWeekLow:            row.fiftyTwoWeekLow,
        timestamp:                  row.timestamp,
        ruleOf40:                   abstractedMetrics.ruleOf40,
    }
*/